// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"FacialServiceStyle_bannerWrapper__SN3UC","bannerService":"FacialServiceStyle_bannerService__wFcLA","bannerMiddlePhoto":"FacialServiceStyle_bannerMiddlePhoto__Gfna4"};